import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../../../_services/invoices.service';
import { ParameterData } from '../../../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_helpers/dataservice.service'
import { Invoice, Account, Debtor } from '../../../_models';
import { CustomerService } from '../../../_services';
import { currencysymbolPrefix } from '../../../_enums/debtordocumenttype';
import { AuthService } from '../../../_services/auth.service';
import { AppConfig } from '../../../_helpers/index';
import * as moment from 'moment';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class CorporateInvoiceEditComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public buttonValidate = false;

  public invoicePublic_key: any;
  public cusAccountPublicKey_temp: Account[] = [];
  public cusAccountPublicKey_ntemp: Account[] = [];
  public cusDebtor: Debtor[] = [];
  public invoiceForm: FormGroup;
  submitted = false;
  due_datetime: any;
  auth0Profile: any;
  ddltotalCurrencySymbol: any[];
  ddlLatefeeCurrencySymbol: any[];
  name: string;
  isalertVisiable = false;
  statusValue: any;
  minDate: any;
  maxDate: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  invoiceid: any;

  // Variables that will be used to indicate the status of debts
  isOverdue: boolean;
  isVoided: boolean;
  isExpired: boolean;
  isReversed: boolean;
  isNew: boolean;

  // Variable that will send the currency value to the accordion to set the form.
  currencySymbolInput: any;

  public user_public_id: string;
  customerSearch: FormControl = new FormControl();
  filteredValue: ReplaySubject<Debtor[]> = new ReplaySubject<Debtor[]>(1);
  private _onDestroy = new Subject<void>();
  searching: boolean = false;
  noEntriesFoundLabel = "No results matched";
  DebtorName = "";
  kashioApplication: any;
  customerFilterData: any[] =[];
  debtorsPublicId: any;

  // Variable I use for invoice status in the setInvoiceDetails() function. 
  status: string;

  // Variable to show if invoice editing fails
  isErrorVisible: boolean;
  statusError: string;
  
  // Variable to indicate whether the account is CORPORATE or PAYMENTS
  APP: string;

  today;
  isDueDatetimeEdit: boolean;

  /** This is Constructor function which is used to initialize the class variables and objects;
  */
  constructor
      (
          private router: Router, private route: ActivatedRoute, private _fb: FormBuilder
          , private parameterData: ParameterData, private dataService: DataService
          , private invoicesService: InvoicesService, private customerService: CustomerService
          , private _currencysymbolPrefix: currencysymbolPrefix
          , private auth: AuthService
          , private spinnerService: Ng4LoadingSpinnerService
      ) {



      this.isalertVisiable = false;

      //this is used to get the Invoice key comes from service; if public key is empty then default key will be asigned.


      this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
      this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;


      this.dataService.currentInvoicePublicKey.subscribe((data) => {
          this.invoicePublic_key = data;
      });


      this.InitialSetup();

      var now = new Date();
      var todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      this.minDate = todayDate;

      var today = new Date();
      var lastDate = new Date(2050, 11, 31);
      this.maxDate = lastDate;


  }//end


  InitialSetup() {

      this.invoiceForm = this._fb.group({
          invoice_id: new FormControl(""),
          metadata: this._fb.group({
              order_id: new FormControl(""),
              order_name: new FormControl("", Validators.required),
              order_description: new FormControl("", Validators.maxLength(250))
          }),
          debtor: this._fb.group({
              public_id: new FormControl("", Validators.required)
          }),
          total: this._fb.group({
              currency: new FormControl("Seleccione", Validators.required),
              value: new FormControl(0, Validators.required)
          }),

          due_datetime: new FormControl(new Date()),
          late_fee: this._fb.group({
              currency: new FormControl("Seleccione", Validators.required),
              value: new FormControl(0, Validators.required)
          }),
          expiration_datetime: new FormControl(new Date()),
          creditor_account: this._fb.group({
              public_id: new FormControl("")
          }),
          fees: this._fb.group({
              currency: new FormControl("Seleccione", Validators.required),
              value: new FormControl(0, Validators.required)
          }),
          sub_total: this._fb.group({
              currency: new FormControl("Seleccione", Validators.required),
              value: new FormControl(0, Validators.required)
          })
      });
  }


  // GetDebtorDetails() {

  //     this.customerService.getCustomerDebtorsList(this.customer_public_id).subscribe(data => {
  //         let resources = data["data"];
  //         this.cusDebtor = resources;

  //     },
  //         error => {
  //             console.log('Failed while trying to the Search All Result. ' + error);
  //         });
  // }//end

  /** This is ngOnInit function called after initialising the component;
   */
  ngOnInit() {

      this.APP = localStorage.getItem('application');
      this.spinnerService.show();
      var browserStorage;
      let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
      if (browserStorage1 == null) {
          browserStorage = localStorage.getItem('companyId');
          if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
              this.router.navigate(['/home']);
          }
          else {
              this.customer_public_id = localStorage.getItem('companyId');
              this.user_public_id = localStorage.getItem('userId');

          }
      }
      else {
          this.customer_public_id = localStorage.getItem('subcompanyId');
          this.user_public_id = localStorage.getItem('userId');
      }

      browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
      this.kashioApplication = localStorage.getItem('application');

      this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
      if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

          this.offsetTimeZone = -5.00;
          this.offsetMinutes = 0;
          this.offsetTimeVal = (this.offsetTimeZone * 3600000);
          AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
      }
      else {

          this.offsetTimeZone = browserStorage.getItem('timezone');
          this.offsetMinutes = 0;

          this.offsetTimeVal = (this.offsetTimeZone * 3600000);
          AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


      }
      //}

      //used to retrieve the customer public id
      let params: any = this.route.snapshot.params;
      this.invoicePublic_key = params.id;

      setTimeout(() => {
          this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
              this.cusAccountPublicKey_temp = data;
              if (this.kashioApplication === "PAYOUTS") {
                  this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'PAYABLE'));
              } else {
                  this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));
              }
          });
      }, 500);
      // this.GetDebtorDetails();
      this.today = moment(new Date()).format('YYYY/MM/DD');
      this.setInvoiceDetails();
      this.customerSearch
          .valueChanges
          //.pipe(takeUntil(this._onDestroy))
          .pipe(debounceTime(500), takeUntil(this._onDestroy))
          .subscribe(() => {
              this.search();
          });
     
      this.invoiceForm.enable();

  }//end

  addDueDateTimeEventEdit(event) {
      if (event.value !== null) {
          const dueDatetimeSelected = (event.value).format('YYYY/MM/DD');
          const daysDifferenceEdit = moment(dueDatetimeSelected).diff(moment(this.today), 'days');

          if (Math.sign(daysDifferenceEdit) === -1) {
              this.isDueDatetimeEdit = false;
          } else {
              this.isDueDatetimeEdit = true;
          }

      } else {
          this.isDueDatetimeEdit = true;
      }
  };

  showButtons():boolean {
          
      if(this.APP === 'CORPORATE') {
          return false;
      } else if ( this.status == 'VOIDED' ){ 
          return false;
      } else if ( this.status == 'EXPIRED' ){ 
          return false;
      } else if ( this.status == 'REVERSED' ){ 
          return false;
      } else {
          return true
      }
  }

  setInvoiceDetails() {
      if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
          this.invoicesService.getInvoice(this.invoicePublic_key).subscribe({
              next: invoice => {
                  this.setDebtorValue(invoice.debtor.public_id, invoice.debtor.name)
                  this.minDate = new Date(invoice.due_datetime.replace(/-/g, "/"));
                  
                  // Variable especially to restrict the edit button to the CORPORATE account.
                  this.status = invoice.status;
                  
                  // Functions that return a boolean value according to the invoice status
                  this.isOverdue = invoice.status === "OVERDUE" ? true : false;
                  this.isVoided = invoice.status === "VOIDED" ? true : false;
                  this.isExpired = invoice.status === "EXPIRED" ? true : false;
                  this.isReversed = invoice.status === "REVERSED" ? true : false;
                  this.isNew = invoice.status === "NEW" ? true : false;

                  this.setSubTotalForm();

                  this.setTotalForm();

                  this.name = invoice.name;
                  this.due_datetime = invoice.due_datetime;
                  this.invoiceid = invoice.invoice_id;
                  this.invoiceForm = this._fb.group({
                      invoice_id: new FormControl(invoice.invoice_id),
                      metadata: this._fb.group({
                          order_id: new FormControl(invoice.metadata.order_id),
                          order_name: new FormControl(invoice.name, Validators.required),
                          order_description: new FormControl(invoice.metadata.order_description, Validators.maxLength(250)),
                      }),
                      debtor: this._fb.group({
                          public_id: new FormControl(invoice.debtor.public_id, Validators.required)
                      }),
                      total: this._fb.group({
                          currency: new FormControl(invoice.total.currency),
                          value: new FormControl(invoice.total.value, Validators.required)
                      }),
                      due_datetime: new FormControl(new Date(invoice.due_datetime.replace(/-/g, "/")).toISOString()),
                      late_fee: this._fb.group({
                          currency: new FormControl(invoice.late_fee.currency),
                          value: new FormControl(invoice.late_fee.value)
                      }),
                      expiration_datetime: new FormControl(new Date(invoice.expiration_datetime.replace(/-/g, "/")).toISOString()),
                      creditor_account: this._fb.group({
                          public_id: new FormControl(invoice.creditor_account == undefined ? '' : invoice.creditor_account.public_id)
                      }),
                      fees: this._fb.group({
                          currency: new FormControl(invoice.fees.currency),
                          value: new FormControl(invoice.fees.value)
                      }),
                      sub_total: this._fb.group({
                          currency: new FormControl(invoice.sub_total.currency),
                          value: new FormControl(invoice.sub_total.value)
                      })
                  });

                  const dueDatetime = moment((invoice.due_datetime)).format('YYYY/MM/DD');
                  const daysDifference = moment(dueDatetime).diff(moment(this.today), 'days');
                  if (Math.sign(daysDifference) === 1 || Math.sign(daysDifference) === 0) {
                      this.isDueDatetimeEdit = true;
                  }
              }, 
              complete: () => {

                  // When the "next" is completed, I make sure that in the "complete" I set the valueChanges 
                  // listener of the "sub_total" field.
                  this.invoiceForm.get('sub_total.value').valueChanges.subscribe({
                      next: sub_total => {

                          // When the field is empty and has no value, any of these cases 
                          // can result, so it is assigned the value 0
                          if(isNaN(parseInt(sub_total)) || !sub_total || sub_total == "" ){
                              sub_total = 0;
                          }
          
                          sub_total = Number(sub_total);
          
                          // I obtain the values of late_ fee and fees and then with the value of sub_total I make the 
                          // calculation and assign this new value to total.
                          const late_fee = this.invoiceForm.get('late_fee.value').value;
                          const fees = this.invoiceForm.get('fees.value').value;
          
                          // parseFloat() is used instead of parseInt() to handle decimals.
                          const result =  parseFloat(sub_total) + parseFloat(late_fee) + parseFloat(fees);
          
                          this.invoiceForm.get('total.value').setValue(result);
                      }
                  });

                  this.invoiceForm.get('sub_total.currency').valueChanges.subscribe({
                      next: sub_total => {
                          this.currencySymbolInput = sub_total;
                          this.invoiceForm.get('late_fee.currency').setValue(sub_total);
                          this.invoiceForm.get('fees.currency').setValue(sub_total);
                          this.invoiceForm.get('total.currency').setValue(sub_total);
                      }
                  });
              }
          })
      }
  };


  async setDebtorValue(id, name) {
      this.debtorsPublicId = id;
      // this.customerService.getCustomerListBySearch(this.customer_public_id, name).subscribe(result => {
      //     this.filteredValue.next(result.data);
      //     this.spinnerService.hide();
      // },
      //     error => {
      //         console.log('Failed while trying to get the customer list.' + error.error)
      //     })
      try {
          const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, name).toPromise();
          this.customerFilterData = data.data;
          this.filteredValue.next(this.customerFilterData.filter(data => data.status == 'ACTIVE' || data.public_id == this.debtorsPublicId));
          this.searching = false;
          this.spinnerService.hide();
      }
      catch (error) {
          console.log('Failed while trying to get the customer list.' + error.error)
      }
  }

  async search() {
      if (this.customerSearch.value.length > 2) {
          this.invoiceForm.get('debtor.public_id').setValue('');
          this.searching = true;
          this.noEntriesFoundLabel = "No results matched " + '"' + this.customerSearch.value + '"';
          // this.customerService.getCustomerListBySearch(this.customer_public_id, this.customerSearch.value).subscribe(result => {
          //     this.filteredValue.next(result.data);
          //     this.searching = false;
          // },
          //     error => {
          //         console.log('Failed while trying to get the customer list.' + error.error)
          //     })
          try {
              const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, this.customerSearch.value).toPromise();
              this.customerFilterData = data.data;
              this.filteredValue.next(this.customerFilterData.filter(data => data.status == 'ACTIVE' || data.public_id == this.debtorsPublicId));
              this.searching = false;
          }
          catch (error) {
              console.log('Failed while trying to get the customer list.' + error.error)
          }
      }
  }

  ngOnDestroy() {
      this.dataService.changeinvoicepublicKey('invoice Key');
      this._onDestroy.next();
      this._onDestroy.complete();
  }



  checkCurrencyDetails(value) {

      if (this.invoiceForm.get('total.currency').value != value) {
          alert("Please select the Currency same Mora and Monto")
      }

  }
  /** This is onsubmit function called for all Invoice Data Save/Update Component;
   */

  enableSaveButton() {
      this.isalertVisiable = false;
      this.buttonValidate = false;
  }
  enableSaveButtonExp() {
      this.isalertVisiable = false;
      this.buttonValidate = false;
  }

  setSubTotalForm() {
      if((this.APP === 'CORPORATE') || (this.isVoided || this.isExpired || this.isReversed)) {
          this.invoiceForm.controls['sub_total'].disable();
      } 
  };

  setTotalForm() { 
      if((this.APP === 'CORPORATE') || (this.isNew || this.isOverdue || this.isReversed || this.isVoided || this.isExpired)) {
          this.invoiceForm.controls['total'].disable();
      } 
  };

  // Function that receives the values emitted from the Output() of the accordion. 
  setDataForm(data: any) {

      // When the field is empty and has no value is assigned the value 0
      if (isNaN(parseFloat(data.late_fee.value))){
          data.late_fee.value = 0;
      } else if (isNaN(parseFloat(data.fees.value))) {
          data.fees.value = 0;
      }

      // Whether the Output data is modified to 0 or not, these values are assigned
      //  to the fields of the form
      this.invoiceForm.get('late_fee.currency').setValue(data.late_fee.currency);
      this.invoiceForm.get('late_fee.value').setValue(data.late_fee.value);

      this.invoiceForm.get('fees.currency').setValue(data.fees.currency);
      this.invoiceForm.get('fees.value').setValue(data.fees.value);
   
      // When the field is empty and has no value, any of these cases 
      // can result, so it is assigned the value 0
      let sub_total = this.invoiceForm.get('sub_total.value').value;
      if(isNaN(parseFloat(sub_total)) || !sub_total || sub_total == "" ){
          sub_total = 0;
      }

      sub_total = Number(sub_total);

      // I obtain the values of late_ fee and fees and then with the value of sub_total I make the 
      // calculation and assign this new value to total.
      // parseFloat() is used instead of parseInt() to handle decimals.
      const result = parseFloat(sub_total) + parseFloat(data.late_fee.value) + parseFloat(data.fees.value);
      this.invoiceForm.get('total.value').setValue(result);
  };

  onsubmit({ value }: { value: Invoice }) {
      this.spinnerService.show();
      this.buttonValidate = true;



      this.cusAccountPublicKey_ntemp = this.cusAccountPublicKey_temp.filter((t => t.balance.currency == value.total.currency));


      value.creditor_account.public_id = this.cusAccountPublicKey_ntemp[0].public_id;

      const debtorInfo = this.customerFilterData.find(debtor => debtor.public_id === value.debtor.public_id);
      if (debtorInfo) {
          value.debtor.external_id = debtorInfo.external_id;
          value.debtor.name = debtorInfo.name;
          value.debtor.phone = debtorInfo.phone;
          value.debtor.email = debtorInfo.email;
          value.debtor.document_type = debtorInfo.document_type;
          value.debtor.document_id = debtorInfo.document_id;
      }
      var momentObj = moment(value.due_datetime);
      var dueDate = momentObj.format("YYYY-MM-DD 00:00:00");

      let dueDateGMT = this.convertGMTTime(dueDate);


      var dateObjexp = new Date(value.expiration_datetime);
      var momentObjexp = moment(dateObjexp);

      var expDate = momentObjexp.format('YYYY-MM-DD 00:00:00');
      let expDateGMT = this.convertGMTTime(expDate);
      value.due_datetime = dueDateGMT;
      value.expiration_datetime = expDateGMT;


      if (value.total.currency == 'S/.') {
          value.late_fee.currency = 'PEN';
          value.late_fee.value = Number(value.late_fee.value);
          value.total.currency = 'PEN';
          value.total.value = Number(value.total.value);
      }

      if (value.total.currency == 'US$') {
          value.late_fee.currency = 'USD';
          value.late_fee.value = Number(value.late_fee.value);
          value.total.currency = 'USD';
          value.total.value = Number(value.total.value);
      }
      value.total.value = Number(value.total.value);
      value.late_fee.value = Number(value.late_fee.value);
      if (value.id === null) {
          value.id = 0;
      }
      value.late_fee.currency = value.total.currency;
      if (this.invoicePublic_key != 'invoice Key') {
          if (value.total.currency == value.late_fee.currency) {
              this.invoicesService.updateInvoice(value, this.invoicePublic_key)
                  .subscribe({
                      next: result => {
                          if(typeof result == "string") {
                              this.statusError = result;
                              this.isErrorVisible = true;
                              this.spinnerService.hide();
                          } else {
                              this.statusValue = "La información fue creada correctamente !";
                              this.isalertVisiable = true;
                              this.spinnerService.hide();
                          }
                      }, error: err => {
                          // If invoice editing fails, code 400 will be generated, so the message will be assigned to "statusError" for rendering in the HTML 
                          // and "isErrorVisible" will be set to true, complying with the *ngIf condition.
                          if (err.status == '400') {

                              this.statusError =  err.error;
                          
                              if(err.error.Description) {
                                  this.statusError =  err.error.Description;
                              }

                              this.isErrorVisible = true;
                          };
                          
                          this.spinnerService.hide();
                          console.log('Failed while trying to update the Invocie Details.' + err);
                      }
                  });
          } else {
              this.spinnerService.hide();
              this.statusValue = "Please select the Currency same Mora and Monto!";
              this.isalertVisiable = true;
          }
      }
  }




  /****GMT Converstion */
  convertGMTTime(convertDate) {
      var dateTimeZoneDiff = convertDate.split(/[- :]/),
          startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);

      if (this.offsetTimeZone > 0) {
          this.offsetMinutes = 30;
          var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
          var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);

          let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
          return tempDate;
      }
      else {
          this.offsetMinutes = 0;
          var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
          var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));

          let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
          return tempDate1;
      }

  }

}
